import { InjectionToken } from '@angular/core';

import { PaymentProvider } from './payment-provider.interface';

/**
 * Token de DI para la pasarela activa. La fábrica vive en `app.config.ts` y
 * elige la implementación según `environment.payments.provider`. Los
 * componentes/servicios inyectan SIEMPRE este token (nunca `environment`
 * directo), para que los tests puedan forzar una implementación con un
 * override de provider.
 *
 * Spec: docs/specs/checkout-payment-step-plan.md §3.7.
 */
export const PAYMENT_PROVIDER = new InjectionToken<PaymentProvider>('PAYMENT_PROVIDER');
